class ContinuousScrollComponent extends HTMLElement {
  constructor() {
    super();
    this.initScrolling();
  }

  initScrolling() {
    const carousel = this.querySelector('.carousel[data-carousel*="carousel-"]');
    if (carousel) {
      this.setupScrolling(carousel);
    }
  }

  setupScrolling(carousel) {
    const speed = parseInt(this.dataset.speed, 10) || 1;
    const scrollAmount = 1;
    const items = Array.from(carousel.children);
    const clone = items.map(item => item.cloneNode(true));
    carousel.append(...clone);

    const totalWidth = carousel.scrollWidth;
    let lastTimestamp = 0;
    let isPaused = false;

    // Pause on hover
    carousel.addEventListener('mouseenter', () => isPaused = true);
    carousel.addEventListener('mouseleave', () => isPaused = false);

    function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;

      if (!isPaused && elapsed > 16) {
        carousel.scrollLeft += scrollAmount * speed;
        if (carousel.scrollLeft >= totalWidth / 2) {
          carousel.scrollLeft = 0;
        }
        lastTimestamp = timestamp;
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }
}

customElements.define('continuous-scroll-component', ContinuousScrollComponent);
